export default __webpack_public_path__ + "static/media/milleage.864cb728.svg";